import { gql } from '@apollo/client'

export const DISPLAY_FACING_ITEM_FRAGMENT = gql`
  fragment DisplayFacingItem on DisplayFacingItem {
    upc
    shelf
    column
    vFacings
    boundingBox {
      coordinates {
        minX
        maxX
        minY
        maxY
      }
    }
  }
`
